import { distinctUntilChanged, filter, map, merge, Subject, tap } from 'rxjs';
import {
  getCookie,
  getData,
  metricsLog,
  setData
} from './utils';
import { AdEventChange, PixelsVideoEvent } from '../../constants/Video';
import { MetricsStorage } from './types';

export const adCompletionTime = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {
  const adTimeChange$ = sub.pipe(
    filter(([type]) => AdEventChange.includes(type as PixelsVideoEvent)),
    map(([, { position, duration }]) => ({ position, duration }),
    distinctUntilChanged<{position: number, duration: number}>((prev, curr) => prev.position === curr.position)),
  );

  const reset$ = sub.pipe(
    filter(([type]) =>PixelsVideoEvent.AD_REQUEST === type),
    map(() => ({ position: 0, duration: 0 })),
    tap(() => metricsLog('reset duration for ads...')),
  );

  merge(adTimeChange$, reset$).subscribe(({ position, duration }) => {
    const uuid = getCookie(pixelsUUIDKey);
    const storageKey = `${uuid}-${typeOfIntegration}`;
    const data:  MetricsStorage = getData(storageKey);
    const dur = duration || data.duration.value;
    const pos = position || data.time_watched.value;

    metricsLog(`Ad Completion time updated to ${pos} out of ${dur}`);

    setData(storageKey, {
      ...data,
      duration: {
        value: dur
      },
      time_watched: {
        value: pos
      }
    });
  });
};